import { Button, Form, Input, InputNumber } from "antd";
import axios from "axios";
import { message } from "@bindeleddet/core/utils";
import { Location } from "@bindeleddet/core/types";
import { useEffect, useState } from "react";

type LocationFormValues = Pick<Location, "name" | "capacity">;

interface Props {
  location?: Location;
  onSuccess: (location: Location) => void;
  onClose: () => void;
}

const CreateOrEditLocation: React.FC<Props> = ({ location, onSuccess, onClose }) => {
  const [form] = Form.useForm<LocationFormValues>();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (location) {
      form.setFieldsValue({
        name: location.name,
        capacity: location.capacity ?? undefined,
      });
    } else {
      form.resetFields();
    }
  }, [location, form]);

  const onFinish = (values: LocationFormValues) => {
    setLoading(true);
    const payload = {
      ...values,
      capacity: values.capacity ?? null,
    };

    const request = location
      ? axios.put<Location>(`/events/locations/${location.id}/`, payload)
      : axios.post<Location>("/events/locations/", payload);

    request
      .then(response => {
        message("success", location ? "Lokasjon oppdatert" : "Lokasjon opprettet");
        onSuccess(response.data);
        onClose();
      })
      .catch(() => message("error", location ? "Kunne ikke oppdatere lokasjon" : "Kunne ikke opprette lokasjon"))
      .finally(() => setLoading(false));
  };

  return (
    <Form form={form} layout="vertical" onFinish={onFinish} initialValues={location ?? {}}>
      <Form.Item<LocationFormValues>
        name="name"
        label="Navn"
        rules={[{ required: true, message: "Skriv inn navn på lokasjonen" }]}
      >
        <Input placeholder="Lokasjonsnavn" />
      </Form.Item>

      <Form.Item<LocationFormValues> name="capacity" label="Kapasitet (valgfritt)">
        <InputNumber placeholder="Antall plasser" style={{ width: "100%" }} min={0} />
      </Form.Item>

      <Form.Item>
        <div style={{ display: "flex", justifyContent: "flex-end", gap: "8px" }}>
          <Button onClick={onClose}>Avbryt</Button>
          <Button type="primary" htmlType="submit" loading={loading}>
            {location ? "Lagre endringer" : "Opprett lokasjon"}
          </Button>
        </div>
      </Form.Item>
    </Form>
  );
};

export default CreateOrEditLocation;
